export var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["MALICIOUS"] = "malicious";
    ErrorTypes["LOCKED"] = "locked";
    ErrorTypes["PROMPT_CLOSED"] = "prompt_closed";
    ErrorTypes["UPGRADE_REQUIRED"] = "upgrade_required";
    ErrorTypes["NO_ACCOUNT"] = "no_account";
    ErrorTypes["LOGIN_REJECTED"] = "login_rejected";
    ErrorTypes["INVALID_METADATA"] = "invalid_metadata";
    ErrorTypes["INVALID_NETWORK"] = "invalid_network";
    ErrorTypes["BAD_PRIVATE_KEY"] = "bad_private_key";
    ErrorTypes["INVALID_ID"] = "invalid_id";
    ErrorTypes["INVALID_ACCOUNT"] = "invalid_account";
    ErrorTypes["ID_EXISTS"] = "id_exists";
    ErrorTypes["ERROR_SAVING"] = "error_saving";
    ErrorTypes["ACCOUNT_REJECTED"] = "account_rejected";
    ErrorTypes["SIGNATURE_REJECTED"] = "signature_rejected";
})(ErrorTypes || (ErrorTypes = {}));
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["NO_SIGNATURE"] = 402] = "NO_SIGNATURE";
    ErrorCodes[ErrorCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    ErrorCodes[ErrorCodes["TIMED_OUT"] = 408] = "TIMED_OUT";
    ErrorCodes[ErrorCodes["LOCKED"] = 423] = "LOCKED";
    ErrorCodes[ErrorCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    ErrorCodes[ErrorCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
})(ErrorCodes || (ErrorCodes = {}));
